module.exports = __webpack_public_path__ + "static/img/bk-about-sp.8283daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bk-about-sp.png
// module id = Od4H
// module chunks = 1